import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import DashboardShell from '../../components/ui/DashboardShell';
import { useCart } from '../../context/CartContext';

const CartPage = () => {
  const { t } = useTranslation();
  const { items, updateQuantity, total } = useCart();

  return (
    <DashboardShell title={t('client.cart.yourCart')} subtitle={t('client.cart.subtitle')}>
      {items.length === 0 ? (
        <p className="text-zinc-600 dark:text-zinc-500">
          {t('client.cart.empty')}{' '}
          <Link to="/marketplace" className="text-glow-400">{t('client.cart.emptyBrowse')}</Link>
        </p>
      ) : (
        <>
          <div className="space-y-4">
            {items.map((item) => (
              <div key={item.productId} className="flex gap-4 rounded-xl border border-zinc-200 dark:border-zinc-800 bg-white dark:bg-zinc-900 p-4">
                {item.image && <img src={item.image} alt="" className="h-20 w-20 rounded-lg object-cover" />}
                <div className="flex-1">
                  <p className="font-medium">{item.name}</p>
                  <p className="text-sm text-zinc-600 dark:text-zinc-500">{item.salonName}</p>
                  {item.basePrice != null && item.basePrice !== item.price && (
                    <p className="mt-1 text-sm text-zinc-500 line-through">{t('common.currency', { amount: Number(item.basePrice || 0).toLocaleString() })}</p>
                  )}
                  <p className="mt-1 text-glow-300">{t('common.currency', { amount: item.price?.toLocaleString() })}</p>
                  {item.campaignName && (
                    <p className="mt-1 text-xs text-emerald-600 dark:text-emerald-400">{t('client.cart.campaignLabel', { name: item.campaignName })}</p>
                  )}
                </div>
                <div className="text-right">
                  <input
                    type="number"
                    min={1}
                    value={item.quantity}
                    onChange={(e) => updateQuantity(item.productId, Number(e.target.value))}
                    className="w-16 rounded border border-zinc-300 dark:border-zinc-700 bg-zinc-50 dark:bg-zinc-950 px-2 py-1 text-sm"
                  />
                  <p className="mt-2 text-sm">{t('common.currency', { amount: (item.price * item.quantity).toLocaleString() })}</p>
                </div>
              </div>
            ))}
          </div>
          <div className="mt-8 flex items-center justify-between rounded-xl border border-zinc-200 dark:border-zinc-800 bg-white dark:bg-zinc-900 p-6">
            <p className="text-lg font-semibold">{t('client.cart.totalLabel', { amount: total.toLocaleString() })}</p>
            <Link to="/client/checkout" className="rounded-lg bg-glow-600 px-6 py-2.5 text-sm font-medium text-white">
              {t('client.cart.checkout')}
            </Link>
          </div>
        </>
      )}
    </DashboardShell>
  );
};

export default CartPage;
